import axios from 'axios';

const headers = { 'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('userDetails'))?.token, 'Accept-Language': localStorage.getItem('currentLanguage')};

const ConsultServiceRequest = axios.create({
    baseURL: process.env.REACT_APP_BASEURL_CONSULTATION_BACKEND,
    headers: headers
});

const AdminServiceRequest = axios.create({
    baseURL: process.env.REACT_APP_BASEURL_ADMIN_BACKEND,
    headers: headers
});
//Dashboard
export const getdataRapport = (data) => ConsultServiceRequest.get('/prestations/ambulatoire/%20', {params: data});
export const getPrestationAmbu = (data) => ConsultServiceRequest.get('/prestation/ambulatoire', {params: data});
export const getPrestationHospi = () => ConsultServiceRequest.get('/prestation/hospitalisation');
export const getPatologieHospi = () => ConsultServiceRequest.get('/patologie/hospitalisation');
export const getPatologieAmbu = (data) => ConsultServiceRequest.get('/patologie/ambulatoire', {params: data});
export const getTopPharmacie = (data) => ConsultServiceRequest.get('/most/pharmacie', {params: data});
export const getTopDentiste = (data) => ConsultServiceRequest.get('/most/dentiste', {params: data});
export const getTopOptique = (data) => ConsultServiceRequest.get('/most/optique', {params: data});
export const getRapportFinance = (data) => ConsultServiceRequest.get('/rapport-finance', {params: data});
export const getRapportDepenseFamille = (data) => ConsultServiceRequest.get('/facture/prestation?numeroPolice='+data.numeroPolice+'&numeroAssure='+data.numeroAssure+'&dateDebut='+data.dateDebut+'&dateFin='+data.dateFin);


//Client
export const globalClientStats = (data, clientIds) => ConsultServiceRequest.post('/data/consommations/souscripteur', clientIds, {params: data});
export const detailedClientStats = (data) => ConsultServiceRequest.get('/consommations/souscripteur', {params: data});
export const visitsClientStats = (data) => ConsultServiceRequest.get('/visites/client', {params: data});
export const consommationsClientStats = (data) => ConsultServiceRequest.get('', {params: data});
export const topConsommationsClientStats = (data) => ConsultServiceRequest.get('', {params: data});

export const getPrestatairesStats = (data) => ConsultServiceRequest.get(`/Etat/prestataires`, {params: data});

// Récupère les statistiques mensuelles
export const getStatsMensuel = (data) => ConsultServiceRequest.get(`/Etat/mensuel`, {params: data});

// Récupère les statistiques hebdomadaires
export const  getStatsHebdomadaire = (data) => ConsultServiceRequest.get(`/Etat/hebdomadaire`, {params: data});

// Récupère les statistiques journalières
export const  getStatsJournalier = (data) => ConsultServiceRequest.get(`/Etat/journalier`, {params: data});

export const   getProvidersStatus = async (params = {}) =>  {
    
      // Préparer les paramètres de requête
      const queryParams = new URLSearchParams();
      
      if (params.dateDebut) {
        queryParams.append('dateDebut', params.dateDebut.toISOString());
      }
      
      if (params.dateFin) {
        queryParams.append('dateFin', params.dateFin.toISOString());
      }
      
      if (params.statusFilter && params.statusFilter !== 'all') {
        queryParams.append('status', params.statusFilter);
      }
      
      if (params.cityFilter && params.cityFilter !== 'all') {
        queryParams.append('cityId', params.cityFilter);
      }
      
      if (params.typeFilter && params.typeFilter !== 'all') {
        queryParams.append('typeId', params.typeFilter);
      }
      
      if (params.searchTerm) {
        queryParams.append('search', params.searchTerm);
      }
      
      // Construire l'URL avec les paramètres
      const url = `/Providerstatus/status?${queryParams.toString()}`;
      
      // Faire la requête API
      const response = await AdminServiceRequest.get(url);
      return response.data;
    
  }

